import { render, staticRenderFns } from "./link_list.vue?vue&type=template&id=62ed2d16&scoped=true&"
import script from "./link_list.vue?vue&type=script&lang=js&"
export * from "./link_list.vue?vue&type=script&lang=js&"
import style0 from "./link_list.vue?vue&type=style&index=0&id=62ed2d16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed2d16",
  null
  
)

export default component.exports